<template>
<div>
  <div class="hello" >
    <div class="box-20150708">
        <img src="../assets/sjzm_01.jpg" />
        <img src="../assets/sjzm_02.jpg" />
        <img src="../assets/sjzm_03.jpg" />
        <img src="../assets/sjzm_04.jpg" />
        <img src="../assets/sjzm_05.jpg" />
        <img src="../assets/sjzm_06.jpg" />
    </div>
  </div>
  <button class="ws-btn" id="linkBtn" @click="linkBtn" >{{msg}}</button>
</div>
</template>

<script>
import {isWeixin} from '../utils/common'
import {checkStatus, wxConfig} from '../utils/actions'
import wx from 'weixin-js-sdk'
import {mapGetters} from 'vuex'
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: '在线报名 ',
      userInfo: ""
    }
  },
  computed:{
    ...mapGetters({
        terantInfo:'getTerantInfo'
    })
  },
  watch: {
    terantInfo(){
      if (isWeixin) {
        console.log(this.terantInfo)
        this.wxShare() // 分享 功能
      }
    }
  },
  mounted () {
    let token = localStorage.getItem("token");
    if(token) this.checkStatus(token);
  },
  methods: {
    async wxShare () {
     let terantInfo =this.terantInfo;
      let data = await wxConfig({shareUrl: location.href.split('#')[0].replace('&', '%26')})
      if (data) {
        data.data.jsApiList = [
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'onMenuShareQZone'
        ]
        wx.config(data.data)
        let wxData = {
          title: terantInfo.brandName+'司机招募', // 分享标题
          desc: '高收入，高保障，时间更自由，'+ terantInfo.brandName+'欢迎您！', // 分享描述
          link: location.origin + '/driver-recruit/index.html',
          imgUrl: terantInfo.logoSmall,
          fail: function (res) {
            alert(JSON.stringify(res))
          }
        }
        console.log(wxData)
        wx.ready(function () {
          wx.checkJsApi({
            jsApiList: ['onMenuShareAppMessage'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function () {
              wx.onMenuShareAppMessage(wxData)
              wx.onMenuShareTimeline(wxData)
              wx.onMenuShareWeibo(wxData)
              wx.onMenuShareQQ(wxData)
              wx.onMenuShareQZone(wxData)
            }
          })
        })
      }
    },
    
    linkBtn () {
       if(!this.userInfo){
         this.$router.push({name: 'login'})
         return
       };
       this.actionLink();
    },
    actionLink () {
      let data = this.userInfo;
      if (data.recycle == '1') {//eslint-disable-line
        this.$router.push({name: 'defeat'})
        return
      };
      // data.status = '1'
      switch (data.status) { // 待完善
        case '1': // 流程第1步报名
          // 报名页面1
          this.$router.push({name: 'signUp', params: {status: data.status}})
          break
        case '2': // 报名成功,
        case '3': // 考试未通过
        case '4': // 考试通过
          // 答题页 2
          this.$router.push({name: 'recruitAnswer', params: {status: data.status}})
          break
        case '5': // 身份证证件未通过
          // 身份证拍照页面
          this.$router.push({name: 'cardIDUpLoad', params: {status: data.status}})
          break
        case '6': // 身份证证件通过
        case '7': // 驾驶证未通过
          // 驾驶证拍照页面
          this.$router.push({name: 'licenceLoad', params: {status: data.status}})
          break
        case '8': // 驾照验证通过
        case '9': // 面试未邀请
        case '10': // 面试已邀请
        case '11': // 面试未通过
          // 信息审核 5
          this.$router.push({name: 'msgAudit', params: {status: data.status}})
          break
        case '12': // 面试通过
        case '13': // 路考未预约
        case '16': // 路考不通过
          // 预约路考页面 6
          this.$router.push({name: 'appointedRoadTest', params: {status: data.status}})
          break
        case '14': // 路考已预约-报名完成
        case '15': // 路考进行中
        case '17': // 路考通过
        case '18': // 成功签约
        case '19': // 已领装备
          this.$router.push({name: 'passStatus', params: {status: data.status}})
          break
        default:
          break
      }

    },
    async checkStatus (token) {
      let data = await checkStatus({token});
      if (!data) return;
      this.userInfo = data.data
      this.$store.commit('USER_INFO', {...data.data,token:token});
    }
  }
}
</script>
<style scoped>
.hello{
  position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    text-align: center;
    font-size: 0;
    white-space: nowrap;
    overflow: auto;
    background: #150d09;
}
/* .hello:after {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
} */
.box-20150708{
  /* display: inline-block; */
    vertical-align: middle;
    text-align: left;
    font-size: 14px;
    white-space: normal;
    /* margin-bottom: 1rem; */
}
.box-20150708 img{
  width: 100%;
  height: auto;
  vertical-align: middle
}
.ws-btn{
  padding: 0;
  margin-left:5%;
  width: 90%;
  /* gradient(-269deg, #F25050 0%, #C93131 100%); */
  background-image: linear-gradient(-269deg, #C93131 0%, #F25050 100%);
  height: 1rem;
  line-height: 1rem;
  font-size: 0.36rem;
  color: #fff;
  border:none;
  border-radius: 1rem;
  position: fixed;
  bottom: .3rem;
  margin-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
  margin-bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */
  }
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue